export default __webpack_public_path__ + "static/media/loading.21f59033.gif";